import { useCallback, useEffect, useState } from 'react';
import { getToken } from '../utils/auth';

// Shadow-mode monitoring - read-only polling of the hybrid Deepgram+Qwen
// comparison stats collected silently alongside production. Same direct-fetch
// pattern as useAsrComparison (simple GETs behind the JWT, no need for the
// RTK Query layer here).
export const useShadowComparison = () => {
  const [state, setState] = useState({
    isLoading: true,
    error: null,
    stats: null,
    items: [],
    meta: null,
  });

  const fetchData = useCallback(async (flaggedOnly = false) => {
    setState((s) => ({ ...s, isLoading: true, error: null }));
    try {
      const base = process.env.REACT_APP_API_BASE || '';
      const token = getToken();
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      const [statsRes, listRes] = await Promise.all([
        fetch(`${base}/api/shadow-comparison/stats`, { headers }),
        fetch(`${base}/api/shadow-comparison?limit=50${flaggedOnly ? '&flaggedOnly=1' : ''}`, { headers }),
      ]);

      const statsBody = await statsRes.json().catch(() => ({}));
      const listBody = await listRes.json().catch(() => ({}));

      if (!statsRes.ok || statsBody?.success === false) {
        throw new Error(statsBody?.error?.message || 'Failed to load shadow comparison stats');
      }
      if (!listRes.ok || listBody?.success === false) {
        throw new Error(listBody?.error?.message || 'Failed to load shadow comparison list');
      }

      setState({
        isLoading: false,
        error: null,
        stats: statsBody.data?.stats || null,
        items: listBody.data?.items || [],
        meta: listBody.data?.meta || null,
      });
    } catch (err) {
      setState((s) => ({ ...s, isLoading: false, error: err.message }));
    }
  }, []);

  useEffect(() => {
    fetchData(false);
  }, [fetchData]);

  return { ...state, refetch: fetchData };
};
